(function ($)
{/* Dom Loaded */
    /* Dom Loaded */
    $(document).ready(function($){
        /* Gallery Ghost v2.1 */
        var images = document.querySelectorAll('.kg-gallery-image img');
        images.forEach(function (image) {
            var container = image.closest('.kg-gallery-image');
            var width = image.attributes.width.value;
            var height = image.attributes.height.value;
            var ratio = width / height;
            container.style.flex = ratio + ' 1 0%';
        })

        $('.kg-gallery-card').each(function(){
            $(this).find('img').wrap(function() {
                return '<a href="'+$(this).attr('src')+'" class="hover-effect" rel="gallery"></a>';
            });
            $(this).magnificPopup({
                type: 'image',
                gallery:{
                    enabled: true,
                    arrowMarkup: '<i class="mfp-arrow mfp-arrow-%dir% fa fa-chevron-%dir%"></i>'
                },
                delegate: 'a',
                mainClass: 'my-mfp-zoom-in',
                removalDelay: 300,
                closeMarkup: '<i title="%title%" class="mfp-close fa fa-times"></i>'
            });
        });
    });
})(jQuery);
